var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.888,
    height: 23.484,
    viewBox: "0 0 17.888 23.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #313280;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13827",
    "data-name": "Path 13827",
    className: "cls-1",
    d: "M78.1,4.874,73.677.69A2.513,2.513,0,0,0,71.943,0h-8.42A2.526,2.526,0,0,0,61,2.523V20.962a2.526,2.526,0,0,0,2.523,2.523H76.366a2.526,2.526,0,0,0,2.523-2.523V6.707A2.533,2.533,0,0,0,78.1,4.874Zm-1.336.63H73.338a.23.23,0,0,1-.229-.229V2.047Zm-.4,16.6H63.523a1.148,1.148,0,0,1-1.147-1.147V2.523a1.148,1.148,0,0,1,1.147-1.147h8.21v3.9A1.607,1.607,0,0,0,73.338,6.88h4.174V20.962A1.148,1.148,0,0,1,76.366,22.108Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13828",
    "data-name": "Path 13828",
    className: "cls-1",
    d: "M138.779,200H128.688a.688.688,0,1,0,0,1.376h10.091a.688.688,0,1,0,0-1.376Z",
    transform: "translate(-63.927 -190.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13829",
    "data-name": "Path 13829",
    className: "cls-1",
    d: "M138.779,280H128.688a.688.688,0,1,0,0,1.376h10.091a.688.688,0,1,0,0-1.376Z",
    transform: "translate(-63.927 -267.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13830",
    "data-name": "Path 13830",
    className: "cls-1",
    d: "M132.023,360h-3.335a.688.688,0,1,0,0,1.376h3.335a.688.688,0,1,0,0-1.376Z",
    transform: "translate(-63.927 -343.488)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.d7113b8efbac602ed33deacafdd2c40e.svg";
export { ForwardRef as ReactComponent };